module.exports = __webpack_public_path__ + "static/media/senseImatgeQuadrat.0d50c446.jpg";